/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { MANAGE_USER_PERMISSIONS_PERMISSIONS_LIST } from './manageUserPermissionsPermissionsList'

export { MANAGE_USER_PERMISSIONS_PERMISSIONS_LIST }
